import { array, create, number, string, min, size, type } from 'superstruct';
export const PayloadItem = type({
    lineItemKey: size(string(), 10, Infinity),
    quantity: min(number(), 0)
});
export const Payload = type({
    items: size(array(PayloadItem), 1)
});
export const makeChangeItemQuantity = function() {
    return async function changeItemQuantity(rawPayload) {
        const { items  } = create(rawPayload, Payload);
        const updates = items.map(({ lineItemKey: id , quantity  })=>({
                id,
                quantity
            }));
        for (const update of updates){
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(update)
            });
            if (!response.ok) {
                const details = await response.json();
                throw new Error(details.description || details.message || 'Cart Update Error');
            }
            await response.json();
        }
    };
};
